import { createContext, createElement, type ReactNode } from 'react';
import { Dialog } from '../../components/Dialog';

export interface AccountFrameProps {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly title: string;
  readonly wide?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
}

/**
 * What the account dialogs are shown in: a modal on the site. An app can show them its own way,
 * such as the desktop app, which makes each a page of its window.
 */
export const AccountFrameContext = createContext<(props: AccountFrameProps) => ReactNode>((props) =>
  createElement(Dialog, props),
);
